import LineClamp from '@dustin-web/microsite-components/src/line-clamp/line-clamp'

export default function PromotedSpecification({ spec }: { spec: { name: string; value: string } }) {
  if (!spec) return null

  return <LineClamp text={`${spec.name} ${spec.value}`} as="li" />
}
